<template>
  <div
    :class="{
      'smart-input--danger': error,
      'smart-input--success': success,
      'smart-input--focus': isFocus,
      'smart-input--disabled cursor-not-allowed': disabled,
    }"
    class="smart-input__wrapper flex align-start flex-col mx-1"
  >
    <div
      class="flex flex-row w-full shrink-1"
      v-if="
        isNotDatePicker &&
        isNotMoney &&
        isNotVolume &&
        isNotVolumeAdapt &&
        isNotMoneyAdapt
      "
    >
      <div
        class="smart-input__prepend rounded-left user-select-none"
        v-if="isPrependedInput"
        @click="$refs.input.focus()"
      >
        {{ prepend }}
        <slot name="input-prepend" />
      </div>
      <input
        ref="input"
        v-mask="configMask"
        v-bind="$attrs"
        @focus="onFocus"
        @blur="onBlur"
        @mousedown="onMouseDown"
        :preventAutocomplete="preventAutocomplete"
        :placeholder="placeholder"
        :id="getInputId()"
        :disabled="disabled"
        :value="value"
        :name="name"
        :type="type"
        :class="{
          'cursor-not-allowed': disabled,
          'rounded-right': isPrependedInput && !isAppendedInput,
          rounded: !isPrependedInput && !isAppendedInput,
          'rounded-left': isAppendedInput && !isPrependedInput,
          'text-center': isPrependedInput || isAppendedInput,
        }"
        class="smart-input shrink-1 grow-1"
        v-on="listeners"
      />
      <div
        class="smart-input__append rounded-right user-select-none"
        v-if="isAppendedInput"
        @click="$refs.input.focus()"
      >
        {{ append }}
        <slot name="input-append" />
      </div>
    </div>
    <DatePicker
      :default-value="defaultValue"
      v-if="isDatePicker"
      v-bind="$attrs"
      :value="value"
      :inline="inline"
      :shortcuts="[]"
      :input-name="name"
      :placeholder="placeholder"
      :disabled-date="disabledDate"
      format="DD/MM/YYYY"
      locale="ptBR"
      lang="pt-br"
      v-on="listeners"
    >
      <template v-slot:calendar-icon>
        <SmartIcon
          class="text-black text-opacity-sm"
          name="calendar"
          :size="2"
        />
      </template>
    </DatePicker>

    <div v-if="setValueInput()" class="flex flex-row w-full shrink-1">
      <money
        :disabled="disabled"
        :class="{
          'cursor-not-allowed': disabled,
        }"
        v-model="price"
        v-bind="formatterMoney"
        class="smart-input shrink-1 grow-1 rounded"
      />
    </div>

    <div class="smart-input__icon" v-if="icon">
      <SmartIcon
        class="text-right align-end mt-1 mr-1"
        :style="{ color: colorIcon }"
        :name="icon"
        :size="2"
      />
    </div>

    <label v-if="label" :for="id" class="smart-label text-left mb-1-2">
      {{ label }}
    </label>

    <div class="smart-feedback" v-if="error || success">
      {{ error || success }}
    </div>
  </div>
</template>

<script>
// @flow
import mask from "vue-the-mask/src/directive";
import tokens from "vue-the-mask/src/tokens";
import { Money } from "v-money";

export default {
  name: "SmartInput",
  components: {
    DatePicker: () => import("vue2-datepicker"),
    Money,
  },
  directives: { mask },
  props: {
    defaultValue: {
      type: Date,
      required: false
    },
    disabledDate: {
      type: Function,
      default: () => {},
      required: false
    },
    preventAutocomplete: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: () => null,
    },
    inline: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: () => null,
    },
    prepend: {
      type: String,
      default: () => null,
    },
    append: {
      type: String,
      default: () => null,
    },
    id: {
      type: String,
      default: () => null,
    },
    icon: {
      type: String,
      default: () => null,
    },
    type: {
      type: String,
      default: "text",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    mask: {
      type: [String, Array],
      required: false,
      default() {
        return "H".repeat(240);
      },
    },
    masked: {
      type: Boolean,
      default: false, // raw
    },
    tokens: {
      type: Object,
      default: () => tokens,
    },
    feedback: {
      type: Object,
      default: () => ({
        type: "",
        text: "",
      }),
    },
    name: {
      type: String,
      default: "",
    },
    colorIcon: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      default: null,
    },
    regexMine: {
      type: RegExp,
      default: () => /.*/g,
    },
    success: {
      type: String,
      default: null,
    },
    value: {}, // eslint-disable-line
    formKey: {
      type: Number,
      default: 1,
    },
  },
  data() {
    let lastLetter = "";

    return {
      isFocus: false,
      customTokens: {
        ...tokens,
        H: { pattern: this.regexMine },
        N: {
          pattern:
            /^([A-Za-z\u00C0-\u00D6\u00D8-\u00f6\u00f8-\u00ff\s `´~˜']*)$/,
          transform: (l) => {
            if (/\s/.test(l) && /\s/.test(lastLetter)) return "";
            lastLetter = l;
            return l;
          },
        },
      },
      price: this.value,
      volume: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 2,
        masked: false,
        maxlength: 14,
      },
      volumeAdapt: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        precision: 10,
        masked: false,
        maxlength: 22,
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 2,
        masked: false,
        maxlength: 14,
      },
      moneyAdapt: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        suffix: "",
        precision: 10,
        masked: false,
        maxlength: 100,
      },
    };
  },
  computed: {
    configMask() {
      return {
        mask: this.mask,
        tokens: this.customTokens,
        masked: this.masked,
      };
    },
    formatterMoney() {
      if (this.isMoney) {
        return this.isMoney;
      } else if (this.isVolume) {
        return this.volume;
      } else if (this.isVolumeAdapt) {
        return this.volumeAdapt;
      } else if (this.isMoneyAdapt) {
        return this.moneyAdapt;
      }

      return false;
    },
    listeners() {
      return {
        ...this.$listeners,
        input: this.onInput,
        focus: this.onFocus,
        blur: this.onBlur,
        mousedown: this.onMouseDown,
      };
    },
    isNotDatePicker() {
      return this.type !== "date-picker" && this.type !== "money";
    },
    isDatePicker() {
      return this.type === "date-picker";
    },
    isMoneyInput() {
      return this.type === "money";
    },
    isMoney() {
      return this.type === "money";
    },
    isNotMoney() {
      return this.type !== "money";
    },
    isVolume() {
      return this.type === "volume";
    },
    isNotVolume() {
      return this.type !== "volume";
    },
    isVolumeAdapt() {
      return this.type === "volumeAdapt";
    },
    isNotVolumeAdapt() {
      return this.type !== "volumeAdapt";
    },
    isMoneyAdapt() {
      return this.type === "moneyAdapt";
    },
    isNotMoneyAdapt() {
      return this.type !== "moneyAdapt";
    },
    isPrependedInput() {
      return !!this.prepend || !!this.$slots["input-prepend"];
    },
    isAppendedInput() {
      return !!this.append || !!this.$slots["input-append"];
    },
  },
  mounted() {
    this.setInputPropertyForTest();
  },
  methods: {
    setValueInput() {
      return (
        this.isMoney || this.isVolume || this.isMoneyAdapt || this.isVolumeAdapt
      );
    },
    getInputId() {
      if (this.id) {
        return this.id;
      }
      if (this.label) {
        return this.transformID(this.label);
      }
      if (this.placeholder) {
        return this.transformID(this.placeholder);
      }
      return this.formKey;
    },
    transformID(data: string) {
      const lowerCaseLabel = data.toLowerCase();
      return `${lowerCaseLabel.replace(/[^a-zA-Z0-9]/g, "")}-${this.formKey}`;
    },
    setInputPropertyForTest() {
      /* eslint-disable */
      const vm = this;
      const { input } = this.$refs;
      if (!input) return;
      const prototype = Object.getPrototypeOf(input);
      const { get, set } = Object.getOwnPropertyDescriptor(prototype, "value");

      Object.defineProperty(input, "value", {
        get(...args) {
          return get.apply(this, args);
        },
        set(...args) {
          const value = args[0];

          vm.onInput({ target: { value } });
          return set.apply(this, args);
        },
      });
      /* eslint-enable */
    },
    onInput(event: InputEvent) {
      if (this.disabled) {
        return;
      }

      if (this.isDatePicker) {
        this.$emit("input", event);
      } else {
        this.$emit("input", event.target.value);
      }
    },
    onFocus() {
      if (this.disabled) {
        return;
      }
      this.isFocus = true;
    },
    onBlur() {
      if (this.disabled) {
        return;
      }
      this.isFocus = false;
    },
    onMouseDown(e) {
      if (this.preventAutocomplete) {
        e.preventDefault();
        if (this.$refs.input.focus) {
          this.$refs.input.blur();
        }
        setTimeout(() => {
          this.$refs.input.focus();
        }, 10);
      }
    },
  },
  watch: {
    price(value: any) {
      this.$emit("input", value);
    },
    value(value: any) {
      if (
        this.isMoney ||
        this.isVolume ||
        this.isVolumeAdapt ||
        this.isMoneyAdapt
      ) {
        this.price = value;
      }
    },
  },
};
</script>

<style lang="scss">
$transition-duration: $transition-sm-medium;
$box-shadow-size: 0 0 0 3px;
$box-shadow-default: $box-shadow-size
  rgba($color-brand-primary, $opacity-low-max);

.smart-input {
  transition-property: border-color, box-shadow;
  transition-duration: $transition-duration;
  transition-timing-function: $transition-easing-default;
  &--focus {
    .smart-label {
      color: $color-brand-primary;
    }
    .smart-input__prepend,
    .smart-input__append {
      background-color: rgba($color-brand-primary, 0.08);
      color: rgba($color-brand-primary, 0.87);
      border-color: $color-brand-primary;
    }
  }
  &:not([disabled]) {
    &:focus {
      outline: none;
      border-color: $color-brand-primary;
      box-shadow: $box-shadow-default;
      + .smart-label {
        color: $color-brand-primary;
      }
    }
    &:hover {
      border-color: $color-brand-primary;
    }
  }

  &--danger {
    &.smart-input--focus {
      .smart-label {
        color: $color-ui-danger;
      }
      .smart-feedback {
        color: $color-ui-danger;
      }
      .smart-input {
        box-shadow: $box-shadow-size rgba($color-ui-danger, $opacity-low-max);
      }
    }
    .smart-input {
      border-color: $color-ui-danger;
      &:not([disabled]) {
        &:hover,
        &:focus {
          border-color: $color-ui-danger;
        }
        &:focus {
          box-shadow: $box-shadow-size rgba($color-ui-danger, $opacity-low-max);
          + .smart-label {
            color: $color-ui-danger;
          }
        }
      }
    }
    .smart-label {
      color: $color-ui-danger;
    }
    .smart-feedback {
      color: $color-ui-danger;
    }
  }

  &--success {
    &.smart-input--focus {
      .smart-label {
        color: $color-brand-secondary;
      }
      .smart-feedback {
        color: $color-brand-secondary;
      }
      .smart-input {
        box-shadow: $box-shadow-size rgba($color-ui-danger, $opacity-low-max);
      }
    }
    .smart-input {
      border-color: $color-brand-secondary;
    }
    .smart-label {
      color: $color-brand-secondary;
    }
    .smart-feedback {
      color: $color-brand-secondary;
    }
  }

  &--disabled {
    opacity: 0.6;
  }

  &__wrapper {
    position: relative;

    .mx-datepicker {
      max-width: 100%;
      width: 100%;
    }
    .mx-input {
      @extend .smart-input;
      box-shadow: none;
      font-size: $font-size-default;
    }
    .mx-datepicker-popup {
      border-radius: $border-radius-default;
      border: 1px solid rgba($color-ui-black, $opacity-low-min);
    }
    .mx-calendar-content .cell {
      user-select: none;
      &.actived {
        background: $color-brand-primary;
      }
      &.disabled {
        color: rgba($color-ui-gray, $font-opacity-md);
        background-color: rgba($color-ui-gray, $opacity-low-min);
      }
      &.today:not(.actived) {
        color: $color-brand-primary;
      }
      &:not(.actived):not(.disabled) {
        &.last-month.inrange,
        &.next-month.inrange {
          color: rgba($color-brand-primary, $font-opacity-sm);
          background-color: rgba($color-brand-primary, $opacity-low-min);
        }
      }
    }
    .mx-input-append {
      width: 40px;
      display: flex;
      align-items: center;
    }
    &.smart-input--danger {
      margin-bottom: 0 !important;
      .mx-input {
        border-color: $color-ui-danger !important;
        @extend .smart-input;
      }
    }
  }
  &__icon {
    position: absolute;
    right: 0;
  }
  &__prepend,
  &__append {
    align-items: center;
    background-color: rgba(202, 202, 202, 0.1);
    border: 1px solid rgba($color-ui-gray, 0.56);
    color: rgba($color-ui-gray, 0.56);
    cursor: default;
    display: inline-flex;
    flex-shrink: 0;
    flex-direction: row;
    min-width: 24px;
    height: 40px;
    padding: 0 $spacing-margin-xxsmall;
    text-align: center;
    transition-property: background-color, border-color, color;
    transition-duration: $transition-duration;
    transition-timing-function: $transition-easing-default;
    white-space: nowrap;
  }
  &__prepend {
    border-right: none;
  }
  &__append {
    border-left: none;
  }
}

.smart-label {
  font-family: $font-family-02;
  color: $color-ui-gray;
  margin-bottom: $spacing-margin-xxxsmall;
  transition: color $transition-duration $transition-easing-default;
  order: -1;
}

.smart-feedback {
  font-family: $font-family-01;
  color: $color-ui-gray;
  margin-top: $spacing-margin-xxxsmall;
  align-self: flex-end;
  font-size: $font-size-paragraph;
}

.smart-input {
  -webkit-appearance: none;
  border: 1px solid rgba($color-ui-gray, 0.56);
  flex-shrink: 1;
  font-family: $font-family-02;
  height: 40px;
  min-width: 24px;
  padding: 0 $spacing-padding-xxsmall;
}

.smart-input::placeholder {
  font-family: $font-family-01;
  color: #000000;
  font-size: 16px;
  opacity: $opacity-low-max;
}
</style>

<style lang="scss">
.mx-calendar-header {
  .mx-icon-last-year,
  .mx-icon-next-year {
    display: none;
  }
  [class*="mx-current"] {
    font-family: $font-family-01;
    font-size: 14px;
    font-weight: 500;
    transition-property: color;
    transition-duration: $transition-sm-fast;
    transition-timing-function: $transition-easing-default;
    user-select: none;
    &:hover {
      color: $color-brand-primary;
    }
  }
  .mx-icon-last-month,
  .mx-icon-next-month {
    height: 30px;
    width: 30px;
    display: inline-block;
    font-size: 30px;
    line-height: 25px;
    border-radius: $border-radius-circle;
    transition-property: color, background;
    transition-duration: $transition-sm-slow;
    transition-timing-function: $transition-easing-default;
    user-select: none;
    &:hover {
      color: $color-brand-primary;
      background: rgba($color-brand-primary, $opacity-low-min);
    }
    &:active {
      color: $color-brand-primary;
      background: rgba($color-brand-primary, $opacity-low-max);
    }
  }
}

.mx-calendar-content .cell {
  &:not(.actived):not(.disabled) {
    &:hover,
    &.inrange {
      background: rgba($color-brand-primary, $opacity-low-half);
    }
  }
}
</style>
